module.exports = __webpack_public_path__ + "img/awards5.d5d9ef1b.svg";